<div class="headlines2" style="text-decoration: underline">Imprint</div>
<div
  style="max-width: 900px; margin: auto; font-size: medium; text-align: justify"
>
  <ul style="margin-top: 10px">
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Provider Information</span><br />
      Department of Medical Bioinformatics, University Medical Center
      Göttingen<br />
      Goldschmidtstraße 1<br />
      37077 Göttingen<br />
      Germany<br />

      Website: <a href='https://bioinformatics-umg.eu'>https://bioinformatics-umg.eu</a>
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold"
        >Responsible for Content (as per § 18 Abs. 2 MStV)</span
      ><br />
      Prof. Tim Beißbarth <br />
      Goldschmidtstraße 1<br />
      37077 Göttingen <br />
      Germany <br />
      Phone: +49 551 3961782
    </li>
  </ul>
</div>
